const _ = require('lodash');
const { DISTRIBUTION_STATUS, DEFAULT_DEVICE_VALUES, DESIGN_PROPS, BEHAVIOR_PROPS } = require('../constants/distribution');
const { DeviceType, SurveySetting, SurveyType } = require('../prisma/types');

const { INACTIVE } = DISTRIBUTION_STATUS;

const DISTRIBUTION_METHOD = {
  EMBEDDED: 'embedded',
  DELAYED: 'delayed',
  EXISTING_BUTTON: 'existingButton',
  BUTTON: 'button',
};

const DISTRIBUTION_METHODS = [
  DISTRIBUTION_METHOD.EMBEDDED,
  DISTRIBUTION_METHOD.DELAYED,
  DISTRIBUTION_METHOD.EXISTING_BUTTON,
  DISTRIBUTION_METHOD.BUTTON,
];

function getDistributionProps(setting, props, dist, distributions) {
  const distSetting = dist[setting];

  const deviceType = dist.deviceTypes.length ? dist.deviceTypes[0] : DeviceType.Desktop;

  const defaultValues = _.omitBy(_.pick(DEFAULT_DEVICE_VALUES[dist.survey.type][deviceType], props), _.isNil);

  if (distSetting === SurveySetting.Default) {
    return defaultValues;
  }

  const otherDists = distributions.filter(d => d.id !== dist.id);

  if (distSetting === SurveySetting.Primary) {
    const primaryDist = otherDists.find((d) => d.survey.languageParent.id === dist.survey.languageParent.id && d.survey.primary && d.survey.version === dist.survey.version && d.deviceTypes.includes(deviceType));
    if (primaryDist) {
      return getDistributionProps(setting, props, primaryDist, otherDists);
    }
  }

  for (const device of Object.values(DeviceType)) {
    if (distSetting === device && !dist.deviceTypes.includes(device)) {
      const deviceDist = otherDists.find((d) => d.survey.id === dist.survey.id && d.deviceTypes.includes(device));
      if (deviceDist) {
        return getDistributionProps(setting, props, deviceDist, otherDists);
      }
    }
  }

  return {
    ...defaultValues,
    ..._.omitBy(_.pick(dist, props), _.isNil),
  };
}

function resolveDistributionProps(dist, distributions) {
  const distWithProps = distributions.find(d => d.id === dist.id);
  const { behaviorSetting, designSetting } = distWithProps;

  const behavior = behaviorSetting ? getDistributionProps('behaviorSetting', BEHAVIOR_PROPS, distWithProps, distributions) : {};

  const designProps = [...DESIGN_PROPS];

  if (behavior.container !== 'embed') {
    designProps.push('container');
  }

  const design = designSetting ? getDistributionProps('designSetting', designProps, distWithProps, distributions) : {};

  return {
    ..._.omitBy(dist, _.isNil),
    ...behavior,
    ...design,
  };
}

const getDistributionMethod = (distribution = {}, surveyType) => {
  if (distribution.behaviorSetting === SurveySetting.Disabled) {
    return null;
  }

  const { container, trigger } = distribution;

  if (container === 'embed') {
    return DISTRIBUTION_METHOD.EMBEDDED;
  }
  if (trigger === 'existingButton') {
    return DISTRIBUTION_METHOD.EXISTING_BUTTON;
  }
  if (trigger === 'button' || surveyType === SurveyType.Feedback) {
    return DISTRIBUTION_METHOD.BUTTON;
  }
  if (surveyType === SurveyType.Cx) {
    return null;
  }
  return DISTRIBUTION_METHOD.DELAYED;
};

const getDistributionMethods = (distributions, surveyType) => {
  if (!distributions?.length) {
    return [];
  }

  const methods = new Set(distributions.map(d => getDistributionMethod(d, surveyType)).filter(Boolean));
  return DISTRIBUTION_METHODS.filter(method => methods.has(method));
};

const getCombinedDistributionStatus = (arr) => {
  if (!arr?.length) {
    return INACTIVE;
  }

  const statusArr = Object.values(DISTRIBUTION_STATUS);
  for (let i = 0; i < statusArr.length; i += 1) {
    if (arr.some((s) => s.status === statusArr[i])) {
      return statusArr[i];
    }
  }

  return INACTIVE;
};

module.exports = {
  DISTRIBUTION_METHOD,
  DISTRIBUTION_METHODS,
  getCombinedDistributionStatus,
  getDistributionMethod,
  getDistributionMethods,
  getDistributionProps,
  resolveDistributionProps,
};
